<template>
  <section class="telegram-recovery" data-test="telegram-delivery-recovery" aria-live="polite">
    <p>{{ $t('auth.telegramRecovery.explanation') }}</p>
    <a
      v-if="recovery?.botUrl"
      :href="recovery.botUrl"
      target="_blank"
      rel="noopener noreferrer"
      data-test="delivery-bot-link"
      class="telegram-recovery__link"
    >{{ $t('auth.telegramRecovery.openBot') }}</a>
    <BaseButton
      v-if="recovery?.channels.includes('telegram')"
      monochrome
      block
      type="button"
      :disabled="busy"
      data-test="delivery-retry-telegram"
      @click="emit('retry', 'telegram')"
    >{{ $t('auth.telegramRecovery.retryTelegram') }}</BaseButton>
    <BaseButton
      v-if="recovery?.channels.includes('email')"
      monochrome
      block
      variant="ghost"
      type="button"
      :disabled="busy"
      data-test="delivery-retry-email"
      @click="emit('retry', 'email')"
    >{{ $t('auth.telegramRecovery.useEmail') }}</BaseButton>
    <BaseButton
      monochrome
      block
      variant="ghost"
      type="button"
      data-test="delivery-back"
      @click="emit('back')"
    >{{ $t('auth.changeEmail') }}</BaseButton>
    <p v-if="errorMessage" role="alert">{{ errorMessage }}</p>
  </section>
</template>

<script setup lang="ts">
import BaseButton from '@/shared/components/base/BaseButton.vue'
import type { OtpChoiceChannel } from '@/modules/profile/api/profileApi'
import type { TelegramRecovery } from '../utils/telegramDeliveryRecovery'

defineProps<{ recovery: TelegramRecovery | null; busy: boolean; errorMessage?: string }>()
const emit = defineEmits<{
  (event: 'retry', channel: OtpChoiceChannel): void
  (event: 'back'): void
}>()
</script>

<style scoped lang="scss">
.telegram-recovery {
  display: grid;
  gap: 16px;
  color: var(--ds-text);
  line-height: 1.5;

  &__link {
    color: var(--ds-text);
    text-decoration: underline;

    &:focus-visible {
      outline: 2px solid currentColor;
      outline-offset: 4px;
    }
  }
}
</style>
